import {Box, Flex} from '@indoqa/style-system'
import * as React from 'react'
import {UserManagementResource} from '../../state/user-management.types'
import {hl} from '../commons/Highlight.utils'

interface Props {
  resource: UserManagementResource
  filterValue: string
}

export function PermissionSelectorItem({resource, filterValue}: Props) {
  return (
    <Flex fullWidth fontSize="small" pb={1} overflowHidden>
      <Box ellipsis pt={1}>
        {hl(resource.name, filterValue)}
      </Box>
    </Flex>
  )
}
